import auth from './auth'
import formtemplate from './formtemplate'
import userform from './userform'
import cases from './cases'
import users from './users'
import reports from './reports'
import bulkmail from './bulkmail'
import bulkops from './bulkops'
import email from './email'

export default {
  auth,
  formtemplate,
  userform,
  cases,
  users,
  reports,
  bulkmail,
  bulkops,
  email
}
